export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "es": {
        "labels": {
          "title": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Crear empaques en contenedor ", _interpolate(_named("container_code"))])},
          "save_button": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Guardar"])},
          "add_link": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Agregar"])},
          "update_link": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Actualizar"])},
          "go_back_link": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Volver al contenedor"])},
          "cancel_button": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Cancelar"])}
        }
      },
      "en": {
        "labels": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Create packages"])},
          "save_button": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Save"])},
          "add_link": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Add"])},
          "update_link": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Update"])},
          "go_back_link": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Go back to container"])},
          "cancel_button": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Cancel"])}
        }
      }
    }
  })
}